import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiStoresList, apiStoresView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/stores/getData', async datas => {
    const { data } = await apiStoresList(datas)
    return data
})

export const getView = createAsyncThunk('admin/stores/getView', async id => {
    if (!id) return viewData
    const { data } = await apiStoresView(id)
    data.image = ''
    return data
})

const viewData = {
    name: '',
    max_limit: '',
    image: '',
    address: '',
    country_id: '',
    state_id: '',
    city_id: '',
    pincode: '',
}

export const storesSlice = createSlice({
    name: 'admin/stores',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = storesSlice.actions

export default storesSlice.reducer
